/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CodeViewModel } from './codeViewModel';

export interface AddProcedureViewModel {
  datasetId?: string;
  code?: string | null;
  description?: string | null;
  procedureComponentType?: string | null;
  defaultModifier1Id?: string | null;
  modifier?: CodeViewModel;
  defaultModifier2Id?: string | null;
  defaultModifier3Id?: string | null;
  defaultModifier4Id?: string | null;
  fee?: number;
  typeOfService?: string | null;
  reportingTypeId?: string | null;
  rvuType?: string | null;
  descriptionRequired?: boolean;
  insuranceCode1?: string | null;
  insuranceCode2?: string | null;
  insuranceCode3?: string | null;
  insuranceCode4?: string | null;
  insuranceCode5?: string | null;
  inactive?: boolean;
  sendClia?: boolean;
  sendMammo?: boolean;
  defaultHoldBilling?: boolean;
  revenueCodeId?: string | null;
}
